/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActionDataStructure } from './ActionDataStructure';
import type { BeforeNotices } from './BeforeNotices';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';

export type PublishToAlertsActionStructure = {
  actionStatus?: PublishToAlertsActionStructure.actionStatus;
  description?: NaturalLanguageStringStructure;
  actionData?: Array<ActionDataStructure>;
  beforeNotices?: BeforeNotices;
  clearNotice?: boolean;
  byEmail?: boolean;
  byMobile?: boolean;
};

export namespace PublishToAlertsActionStructure {
  export enum actionStatus {
    OPEN = 'OPEN',
    PUBLISHED = 'PUBLISHED',
    CLOSED = 'CLOSED',
  }
}
